import { graphql } from 'react-relay';

export const awardsListBlockFragment = graphql`
    fragment AwardsListBlock_contentBlock on AwardsList
    @refetchable(queryName: "AwardsListBlockPaginationQuery")
    @argumentDefinitions(
        count: { type: "Int", defaultValue: 4 }
        cursor: { type: "String" }
    )
    {
        id
        awardsTitle: title
        items(last: $count, before: $cursor)
        @connection(key: "AwardsListBlock_items") {
            pageInfo {
                hasPreviousPage
                startCursor
            }
            edges {
                node {
                    year
                    ...AwardsListItem_awardsListItem
                }
            }
        }
    }
`;
